import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDeleteTrash, IcStylusNote } from '@/assets/images';
import { colors } from '@/theme/variables';
const actions = (
  onDelete?: (inspectionId?: string) => void,
  onEdit?: (inspectionId?: string) => void,
): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onEdit?.(params.row?._id);
        }}
      >
        <IcStylusNote />
      </IconButton>
      <IconButton
        sx={{ color: colors.error.main }}
        onClick={(e) => {
          e.stopPropagation();
          onDelete?.(params.row?._id);
        }}
      >
        <IcDeleteTrash />
      </IconButton>
    </>
  ),
});
const photoUrl = () => ({
  field: 'photoUrl',
  headerName: 'Photo',
  disableColumnMenu: true,
  renderCell: (params: any) => {
    return (
      <span>
        <a href={params.row?.photoUrl} style={{ color: colors.error.main }}>
          View photo
        </a>
      </span>
    );
  },
});
export const inspectionVisitNotes = (
  onDelete?: (inspectionId?: string) => void,
  onEdit?: (inspectionId?: string) => void,
) => {
  return {
    actions: () => actions(onDelete, onEdit),
    photoUrl,
  };
};
